import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtokitturtaxi() {



    const cardData = {




keyword: "Belgaum to Kittur Taxi",

headingDescription: "Belgaum Taxi Service provides comfortable and reliable Belgaum to Kittur taxi services for local travel, historical tours, family visits, business trips, and daily transportation needs. We offer convenient one-way taxi, round-trip cab, and customized travel options from Belgaum to Kittur with experienced drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, and groups. With doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support, we ensure a safe and comfortable journey between Belgaum and Kittur. Whether you are visiting Kittur for its historical importance, business requirements, family functions, or sightseeing, Belgaum Taxi Service provides dependable transportation with professional chauffeurs, clean vehicles, and customer-focused service for a smooth travel experience.",

topPlaces: [
  {
    title: "Kittur Fort",
    description: "Kittur Fort is the most famous historical attraction in Kittur, known for its connection with Rani Chennamma and the brave resistance against British rule. The fort showcases Karnataka's rich history, royal heritage, and cultural importance, making it a popular destination for history lovers and tourists."
  },
  {
    title: "Kittur Rani Chennamma Memorial",
    description: "The Rani Chennamma Memorial is dedicated to the legendary queen of Kittur who fought against British forces. It is an important historical site that attracts visitors interested in Karnataka's freedom struggle and royal legacy."
  },
  {
    title: "Belagavi",
    description: "Belagavi is a major city in Karnataka known for its historical landmarks, educational institutions, industries, markets, and cultural attractions. It serves as an important travel hub for nearby destinations including Kittur."
  },
  {
    title: "Belagavi Fort",
    description: "Belagavi Fort is a historic landmark featuring ancient architecture, temples, and cultural sites. It is one of the important attractions for visitors exploring the heritage of the Belgaum region."
  },
  {
    title: "Gokak Falls",
    description: "Gokak Falls is a beautiful natural attraction near Belgaum known for its impressive waterfall, scenic surroundings, suspension bridge, and peaceful environment. It is a popular weekend destination for families and nature lovers."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a famous adventure and nature destination known for wildlife sanctuary, forests, river rafting, jungle activities, and scenic landscapes. It is a preferred getaway for travelers looking for outdoor experiences."
  },
  {
    title: "Goa",
    description: "Goa is a popular coastal holiday destination known for beaches, resorts, churches, water sports, and sightseeing attractions. Travelers from Belgaum often choose private cabs for comfortable Goa trips."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a historic Maharashtra city famous for Mahalaxmi Temple, cultural heritage, traditional markets, cuisine, and business activities. It is a popular destination for religious and family travel."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial city in Maharashtra with corporate offices, technology parks, universities, and commercial centers. It is a preferred destination for business and long-distance travelers."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital known for business districts, airports, entertainment destinations, and famous tourist attractions. Private taxi services provide comfortable interstate connectivity for travelers."
  }
],




"services": [
  {
    "name": "Belgaum to Kittur Taxi",
    "description": "Book Belgaum to Kittur Taxi for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Get Sedan, Ertiga, Innova Crysta, and SUV cab options for local travel, family trips, business journeys, and convenient transportation between Belgaum and Kittur."
  },
  {
    "name": "Belgaum to Kittur Cab",
    "description": "Hire Belgaum to Kittur Cab service for a smooth and hassle-free journey with experienced drivers, clean vehicles, and affordable travel packages. Our cabs are suitable for personal trips, corporate travel, family visits, and short-distance transportation needs."
  },
  {
    "name": "Belgaum to Kittur Taxi Service",
    "description": "Choose Belgaum to Kittur Taxi Service for reliable transportation with professional drivers, comfortable seating, and flexible booking options. Enjoy safe and convenient travel with multiple vehicle choices available for one way and round trip journeys."
  },
  {
    "name": "Belgaum to Kittur Cab Service",
    "description": "Book Belgaum to Kittur Cab Service for convenient travel with doorstep pickup, experienced chauffeurs, and well-maintained vehicles. Our taxi services provide comfortable transportation for families, business travelers, and local passengers."
  },
  {
    "name": "Belgaum to Kittur One Way Cab",
    "description": "Reserve Belgaum to Kittur One Way Cab for affordable single-trip travel without return charges. Enjoy fixed pricing, comfortable AC cars, professional drivers, and convenient pickup facilities for your journey."
  },
  {
    "name": "Belgaum to Kittur One Way Taxi",
    "description": "Book Belgaum to Kittur One Way Taxi for economical and reliable transportation with skilled chauffeurs and comfortable vehicles. Perfect for passengers looking for budget-friendly one direction travel solutions."
  },
  {
    "name": "Belgaum to Kittur Cab Booking",
    "description": "Complete Belgaum to Kittur Cab Booking online with easy reservations, quick confirmation, and multiple vehicle options. Choose Sedan, Ertiga, Innova Crysta, or SUV cabs according to your travel requirements."
  },
  {
    "name": "Belgaum to Kittur Taxi Booking",
    "description": "Book Belgaum to Kittur Taxi Booking services for comfortable and reliable travel with professional chauffeurs. Get affordable taxi options with flexible schedules for personal, family, and corporate journeys."
  },
  {
    "name": "Belgaum to Kittur Car Rental",
    "description": "Choose Belgaum to Kittur Car Rental for private chauffeur-driven vehicles with comfortable seating and professional service. Ideal for family travel, sightseeing, business trips, and convenient transportation."
  },
  {
    "name": "Belgaum to Kittur Outstation Cab",
    "description": "Hire Belgaum to Kittur Outstation Cab for safe and comfortable travel with experienced drivers, clean AC vehicles, and transparent pricing. Enjoy reliable transportation for personal and business requirements."
  },
  {
    "name": "Belgaum to Kittur Innova Crysta Cab",
    "description": "Book Belgaum to Kittur Innova Crysta Cab for premium and spacious travel with luxury seating, large luggage capacity, and experienced chauffeurs. Perfect for families, groups, and comfortable journeys."
  },
  {
    "name": "Belgaum to Kittur Ertiga Cab",
    "description": "Choose Belgaum to Kittur Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family trips, group travel, and convenient local transportation."
  },
  {
    "name": "Belgaum to Kittur Sedan Cab",
    "description": "Book Belgaum to Kittur Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Suitable for individuals, couples, business trips, and smooth journeys."
  },
  {
    "name": "Belgaum to Kittur Round Trip Cab",
    "description": "Hire Belgaum to Kittur Round Trip Cab for flexible return journeys with affordable packages and reliable chauffeurs. Perfect for family visits, sightseeing, business meetings, and weekend travel."
  },
  {
    "name": "Belgaum to Kittur Private Taxi",
    "description": "Reserve Belgaum to Kittur Private Taxi for personalized travel with dedicated vehicles and professional drivers. Enjoy privacy, comfort, and hassle-free transportation throughout your journey."
  },
  {
    "name": "Cheap Belgaum to Kittur Taxi",
    "description": "Find Cheap Belgaum to Kittur Taxi services offering affordable fares with quality vehicles and reliable drivers. Travel comfortably with budget-friendly transportation without compromising safety and convenience."
  },
  {
    "name": "Best Belgaum to Kittur Taxi Service",
    "description": "Choose the Best Belgaum to Kittur Taxi Service with premium vehicles, trained drivers, competitive pricing, and dependable support. Experience smooth and comfortable travel for all journey requirements."
  },
  {
    "name": "Online Belgaum to Kittur Cab Booking",
    "description": "Complete Online Belgaum to Kittur Cab Booking with simple reservations, instant confirmation, and flexible travel options. Select your preferred vehicle and enjoy convenient doorstep pickup services."
  },
  {
    "name": "Belgaum to Kittur Taxi Fare",
    "description": "Check Belgaum to Kittur Taxi Fare for affordable and transparent pricing with no hidden charges. Get comfortable cabs with professional drivers for safe and economical travel."
  },
  {
    "name": "Belgaum to Kittur Car Hire",
    "description": "Hire Belgaum to Kittur Car Hire services for private travel with chauffeur-driven vehicles. Choose from multiple car categories suitable for personal, family, and corporate transportation needs."
  },
  {
    "name": "Belgaum to Kittur Cab Price",
    "description": "Get affordable Belgaum to Kittur Cab Price with flexible packages for one way and round trips. Enjoy quality vehicles, reliable service, and professional drivers at competitive rates."
  },
  {
    "name": "Belgaum to Kittur Family Cab",
    "description": "Book Belgaum to Kittur Family Cab for safe and comfortable family travel with spacious vehicles and experienced chauffeurs. Perfect for family functions, visits, and personal journeys."
  },
  {
    "name": "Belgaum to Kittur Corporate Taxi",
    "description": "Choose Belgaum to Kittur Corporate Taxi services for business travel, employee transportation, and executive journeys. Get punctual service with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Kittur Airport Transfer",
    "description": "Book Belgaum to Kittur Airport Transfer services for timely pickup and drop with comfortable vehicles and experienced chauffeurs. Enjoy stress-free airport transportation with reliable cab availability."
  },
  {
    "name": "Belgaum to Kittur Cab Fare",
    "description": "Get the best Belgaum to Kittur Cab Fare with affordable travel packages and transparent pricing. Travel comfortably with Sedan, Ertiga, Innova Crysta, and SUV cab options."
  },
  {
    "name": "Belgaum to Kittur Taxi Near Me",
    "description": "Find Belgaum to Kittur Taxi Near Me for quick and reliable cab availability with professional drivers. Enjoy convenient booking, doorstep pickup, and comfortable travel anytime."
  },
  {
    "name": "Belgaum to Kittur Outstation Taxi",
    "description": "Book Belgaum to Kittur Outstation Taxi for safe and convenient long-distance travel. Get clean AC vehicles, experienced chauffeurs, and flexible travel plans for personal and business journeys."
  },
  {
    "name": "Belgaum to Kittur Travel by Cab",
    "description": "Experience comfortable Belgaum to Kittur Travel by Cab with reliable transportation, professional drivers, and premium vehicle options. Enjoy a smooth journey with convenient pickup and customized travel solutions."
  }
],
"tableData": [
  ["Belgaum to Kittur Taxi", "Belgaum to Kittur Cab"],
  ["Belgaum to Kittur Taxi Service", "Belgaum to Kittur Cab Service"],
  ["Belgaum to Kittur One Way Cab", "Belgaum to Kittur One Way Taxi"],
  ["Belgaum to Kittur Cab Booking", "Belgaum to Kittur Taxi Booking"],
  ["Belgaum to Kittur Car Rental", "Belgaum to Kittur Outstation Cab"],
  ["Belgaum to Kittur Innova Crysta Cab", "Belgaum to Kittur Ertiga Cab"],
  ["Belgaum to Kittur Sedan Cab", "Belgaum to Kittur Round Trip Cab"],
  ["Belgaum to Kittur Private Taxi", "Cheap Belgaum to Kittur Taxi"],
  ["Best Belgaum to Kittur Taxi Service", "Online Belgaum to Kittur Cab Booking"],
  ["Belgaum to Kittur Taxi Fare", "Belgaum to Kittur Car Hire"],
  ["Belgaum to Kittur Cab Price", "Belgaum to Kittur Family Cab"],
  ["Belgaum to Kittur Corporate Taxi", "Belgaum to Kittur Airport Transfer"],
  ["Belgaum to Kittur Cab Fare", "Belgaum to Kittur Taxi Near Me"],
  ["Belgaum to Kittur Outstation Taxi", "Belgaum to Kittur Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Kittur Taxi Service",
    WhyChoosedescription: "Travel conveniently from Belgaum to Kittur with a trusted taxi service offering comfortable cars, professional drivers, and flexible travel options for local and personal journeys."
  },
  {
    WhyChooseheading: "Quick & Convenient Local Route Travel",
    WhyChoosedescription: "Enjoy smooth transportation between Belgaum and Kittur with easy pickup and drop facilities that save time and provide a hassle-free travel experience."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs based on your passenger count and comfort requirements."
  },
  {
    WhyChooseheading: "Suitable for Family & Business Trips",
    WhyChoosedescription: "Our Belgaum to Kittur taxis are ideal for family visits, business travel, local work, educational trips, and personal transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Travel",
    WhyChoosedescription: "Professional chauffeurs provide timely service, smooth driving, and comfortable rides with proper knowledge of the Belgaum to Kittur route."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Select a one-way taxi for direct travel or book a return cab according to your preferred schedule and travel requirements."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Travel in well-maintained cars with clean interiors and comfortable seating for a pleasant journey between Belgaum and Kittur."
  },
  {
    WhyChooseheading: "Easy Taxi Booking Support",
    WhyChoosedescription: "Get quick assistance for cab availability, fare details, and vehicle selection to arrange your Belgaum to Kittur taxi easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Kittur Taxi Service?",
    answer: "Yes, we provide Belgaum to Kittur taxi services with comfortable vehicles and professional drivers for convenient travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Kittur?",
    answer: "Yes, one-way cab services are available for passengers who need direct transportation between Belgaum and Kittur."
  },
  {
    question: "Which vehicles are available for Belgaum to Kittur travel?",
    answer: "You can choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs according to your travel needs."
  },
  {
    question: "Is Belgaum to Kittur taxi suitable for family travel?",
    answer: "Yes, comfortable vehicles are available for families and groups travelling between Belgaum and Kittur."
  },
  {
    question: "Can I book a return cab from Kittur to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible timings based on your travel plans."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Kittur?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Kittur taxi service available anytime?",
    answer: "Yes, taxi booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Kittur Taxi?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Santosh Patil",
    feedback: "The Belgaum to Kittur taxi service was quick and comfortable. The driver was punctual, and the vehicle was clean and well maintained.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Asha Kulkarni",
    feedback: "We booked a cab for a family visit and had a smooth experience. The service was reliable, comfortable, and easy to arrange.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Kittur Taxi",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-kittur-taxi.webp",
  "description":
    "Book Belgaum to Kittur Taxi with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Kittur with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, local sightseeing, and airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-kittur-taxi"
  }
};






    return (
        <div>



<Helmet>
  <title>Belgaum to Kittur Taxi | Reliable Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Kittur Taxi with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs for affordable and comfortable travel from Belgaum to Kittur with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Belgaum to Kittur Taxi, Belgaum to Kittur Cab, Belgaum to Kittur Taxi Service, Belgaum to Kittur Cab Service, Belgaum to Kittur One Way Cab, Belgaum to Kittur One Way Taxi, Belgaum to Kittur Cab Booking, Belgaum to Kittur Taxi Booking, Belgaum to Kittur Car Rental, Belgaum to Kittur Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtokitturtaxi ;